import { useState, useEffect } from 'react';

interface PlatformInfo {
  isAndroid: boolean;
  isIOS: boolean;
  isWebView: boolean;
  isMobile: boolean;
  canUseFullscreen: boolean;
}

export const usePlatform = (): PlatformInfo => {
  const [platform, setPlatform] = useState<PlatformInfo>({
    isAndroid: false,
    isIOS: false,
    isWebView: false,
    isMobile: false,
    canUseFullscreen: false,
  });

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    
    const isAndroid = /android/.test(userAgent);
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    const isWebView = /(wv|webview)/.test(userAgent);
    const isMobile = isAndroid || isIOS;
    const canUseFullscreen = document.fullscreenEnabled || 
                             (document as any).webkitFullscreenEnabled;

    setPlatform({
      isAndroid,
      isIOS,
      isWebView,
      isMobile,
      canUseFullscreen,
    });

    console.log('🔍 Platform detected:', {
      isAndroid,
      isIOS,
      isWebView,
      isMobile,
      canUseFullscreen,
      userAgent
    });
  }, []);

  return platform;
};
